import {
  AUTO_TOGGLE_GAP_RATIO,
  AUTO_TOGGLE_HEIGHT_RATIO,
  AUTO_TOGGLE_WIDTH_RATIO,
  YUT_BUTTON_ASPECT,
  YUT_BUTTON_WIDTH_RATIO,
  YUT_BUTTON_MARGIN_X,
  YUT_BUTTON_MARGIN_Y,
  yutButtonAnim,
} from "./state.js";
import { easeOutCubic } from "./utils.js";

export function getYutButtonRect(panelRect) {
  const width = panelRect.width * YUT_BUTTON_WIDTH_RATIO;
  const height = width / YUT_BUTTON_ASPECT;
  const left = panelRect.left + panelRect.width - panelRect.width * YUT_BUTTON_MARGIN_X - width;
  const bottom = panelRect.bottom + panelRect.height * YUT_BUTTON_MARGIN_Y;
  let offset = 0;
  if (yutButtonAnim.active || yutButtonAnim.progress < 1) {
    const t = Math.min(1, Math.max(0, yutButtonAnim.progress));
    offset = (1 - easeOutCubic(t)) * (panelRect.height + height);
  }
  return {
    left,
    bottom: bottom + offset,
    width,
    height,
  };
}

export function getAutoToggleRect(panelRect) {
  const buttonRect = getYutButtonRect(panelRect);
  const width = buttonRect.width * AUTO_TOGGLE_WIDTH_RATIO;
  const height = buttonRect.height * AUTO_TOGGLE_HEIGHT_RATIO;
  const left = buttonRect.left + buttonRect.width - width - width * 0.08;
  const bottom =
    buttonRect.bottom + buttonRect.height + buttonRect.height * (AUTO_TOGGLE_GAP_RATIO - 0.16);
  return {
    left,
    bottom,
    width,
    height,
  };
}

export function getBenchCenters(panelRect) {
  const buttonRect = getYutButtonRect(panelRect);
  const baseY = buttonRect.bottom + buttonRect.height + panelRect.height * 0.1;
  const centerX = buttonRect.left + buttonRect.width * 0.5;
  const spread = buttonRect.width * 0.08;
  return {
    player: {
      x: centerX - spread,
      y: baseY + panelRect.height * 0.06,
    },
    monster: {
      x: centerX + spread,
      y: baseY + panelRect.height * 0.06,
    },
  };
}
